"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Tabs", {
    enumerable: true,
    get: function() {
        return Tabs;
    }
});
var _react = _interop_require_default(require("react"));
var _react1 = require("@chakra-ui/react");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Tabs = function(props) {
    return _react.default.createElement(_react1.Tabs, props);
};
Tabs.List = _react1.TabList;
Tabs.Item = _react1.Tab;
Tabs.Panels = _react1.TabPanels;
Tabs.Panel = _react1.TabPanel;
